import React from "react";
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
  SideBtnWrap,
  SidebarRoute,
} from "./SidebarElements";

const Sidebar = ({ isOpen, toggle }) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink to="ladowe" onClick={toggle}>
            Lądowe
          </SidebarLink>
          <SidebarLink to="powietrzne" onClick={toggle}>
            Powietrzne
          </SidebarLink>
          <SidebarLink to="wodne" onClick={toggle}>
            Wodne
          </SidebarLink>
          {/* <SidebarLink to="services" onClick={toggle}>
            O mnie
          </SidebarLink> */}
        </SidebarMenu>
        <SideBtnWrap>
          <SidebarRoute to="/signin">Ja</SidebarRoute>
        </SideBtnWrap>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
